(function () {
  'use strict';

  var F3DDEVIS2026_CLE = 'f3ddevis2026_liste';
  var F3DDEVIS2026_TVA = 1.2;
  var F3DDEVIS2026_CLE_DATE = 'f3ddevis2026_maj';
  var F3DDEVIS2026_DUREE = 10 * 24 * 60 * 60 * 1000;

  function f3ddevis2026Purger() {
    try {
      var marque = parseInt(window.localStorage.getItem(F3DDEVIS2026_CLE_DATE), 10);
      if (isNaN(marque)) return false;
      if (Date.now() - marque < F3DDEVIS2026_DUREE) return false;
      window.localStorage.removeItem(F3DDEVIS2026_CLE);
      window.localStorage.removeItem(F3DDEVIS2026_CLE_DATE);
      return true;
    } catch (e) {
      return false;
    }
  }

  function f3ddevis2026Lire() {
    try {
      if (f3ddevis2026Purger()) return [];
      var brut = window.localStorage.getItem(F3DDEVIS2026_CLE);
      var liste = brut ? JSON.parse(brut) : [];
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      return [];
    }
  }

  function f3ddevis2026Ecrire(liste) {
    try {
      window.localStorage.setItem(F3DDEVIS2026_CLE, JSON.stringify(liste));
      if (!liste.length) {
        window.localStorage.removeItem(F3DDEVIS2026_CLE_DATE);
      } else if (!window.localStorage.getItem(F3DDEVIS2026_CLE_DATE)) {
        window.localStorage.setItem(F3DDEVIS2026_CLE_DATE, String(Date.now()));
      }
    } catch (e) {}
    document.dispatchEvent(
      new CustomEvent('f3ddevis2026:change', { detail: liste })
    );
  }

  var F3DDevis2026 = {
    liste: f3ddevis2026Lire,

    nombre: function () {
      return f3ddevis2026Lire().reduce(function (t, l) { return t + l.qte; }, 0);
    },

    ajouter: function (article) {
      if (!article.sku) return false;
      var liste = f3ddevis2026Lire();
      var trouve = false;
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].sku === article.sku) {
          liste[i].qte += article.qte;
          trouve = true;
          break;
        }
      }
      if (!trouve) liste.push(article);
      f3ddevis2026Ecrire(liste);
      return true;
    },

    retirer: function (sku) {
      f3ddevis2026Ecrire(
        f3ddevis2026Lire().filter(function (l) { return l.sku !== sku; })
      );
    },

    definirQte: function (sku, qte) {
      var liste = f3ddevis2026Lire();
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].sku === sku) liste[i].qte = Math.max(1, parseInt(qte, 10) || 1);
      }
      f3ddevis2026Ecrire(liste);
    },

    vider: function () {
      f3ddevis2026Ecrire([]);
    },

    prixHT: function (article) {
      var centimes = parseInt(article.prix, 10);
      if (isNaN(centimes)) return null;
      return Math.round(centimes * article.qte / F3DDEVIS2026_TVA) / 100;
    },

    totalHT: function () {
      var total = 0;
      var lignes = f3ddevis2026Lire();
      for (var i = 0; i < lignes.length; i++) {
        var ligne = F3DDevis2026.prixHT(lignes[i]);
        if (ligne !== null) total += ligne;
      }
      return Math.round(total * 100) / 100;
    },

    totalTTC: function () {
      var total = 0;
      var lignes = f3ddevis2026Lire();
      for (var i = 0; i < lignes.length; i++) {
        var centimes = parseInt(lignes[i].prix, 10);
        if (!isNaN(centimes)) total += centimes * lignes[i].qte;
      }
      return Math.round(total) / 100;
    },

    formaterEuros: function (montant) {
      return montant.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '\u00A0\u20AC';
    },

    versTexte: function () {
      return f3ddevis2026Lire().map(function (l, i) {
        var dispo = l.stock;
        var enStock = parseInt(l.stock, 10);
        if (!isNaN(enStock) && l.qte <= enStock) {
          dispo = enStock + ' (en stock)';
        }
        return (i + 1) + '. ' + l.titre +
          '\n   Reference : ' + l.sku +
          '\n   Quantite demandee : ' + l.qte +
          '\n   Disponibilite affichee sur le site : ' + dispo +
          '\n   ' + l.url;
      }).join('\n\n');
    },

    versTexteClient: function () {
      return f3ddevis2026Lire().map(function (l, i) {
        return (i + 1) + '. ' + l.titre +
          '\n   Reference : ' + l.sku +
          '\n   Quantite demandee : ' + l.qte +
          '\n   ' + l.url;
      }).join('\n\n');
    }
  };

  window.F3DDevis2026 = F3DDevis2026;

  function f3ddevis2026Quantite() {
    var champ = document.querySelector('[data-product-form] [data-quantity-input]');
    var n = champ ? parseInt(champ.value, 10) : 1;
    return Math.max(1, isNaN(n) ? 1 : n);
  }

  function f3ddevis2026InitBouton() {
    var zone = document.querySelector('[data-f3ddevis2026-ajout]');
    if (!zone) return;

    var bouton = zone.querySelector('[data-f3ddevis2026-bouton]');
    var rappel = zone.querySelector('[data-f3ddevis2026-rappel]');
    var lien = zone.querySelector('[data-f3ddevis2026-lien]');
    var compteur = zone.querySelector('[data-f3ddevis2026-compteur]');
    if (!bouton) return;

    var libelle = bouton.innerHTML;
    var minuteur = null;
    var attente = null;

    function aligner() {
      var atc = document.querySelector('[data-product-form] .product-form--atc-button');
      if (!atc) return;
      var cible = atc.getBoundingClientRect();
      var base = zone.getBoundingClientRect();
      if (cible.width < 1 || base.width < 1) return;

      var decalage = Math.max(0, Math.round(cible.left - base.left));
      var hauteur = Math.round(cible.height);

      bouton.style.width = Math.round(cible.width) + 'px';
      bouton.style.marginLeft = decalage + 'px';
      if (rappel) rappel.style.paddingLeft = decalage + 'px';

      bouton.style.height = '';
      bouton.style.height = bouton.scrollHeight <= hauteur ? hauteur + 'px' : '';
    }

    bouton.addEventListener('click', function () {
      var etaitMasque = rappel ? rappel.hidden : false;

      var ok = F3DDevis2026.ajouter({
        sku: zone.getAttribute('data-f3ddevis2026-sku'),
        titre: zone.getAttribute('data-f3ddevis2026-titre'),
        url: zone.getAttribute('data-f3ddevis2026-url'),
        stock: zone.getAttribute('data-f3ddevis2026-stock'),
        prix: zone.getAttribute('data-f3ddevis2026-prix'),
        qte: f3ddevis2026Quantite()
      });

      if (ok && rappel && etaitMasque) {
        rappel.classList.remove('f3ddevis2026-rappel--anime');
        void rappel.offsetWidth;
        rappel.classList.add('f3ddevis2026-rappel--anime');
      } else if (ok && compteur) {
        compteur.classList.remove('f3ddevis2026-compteur--maj');
        void compteur.offsetWidth;
        compteur.classList.add('f3ddevis2026-compteur--maj');
      }

      clearTimeout(minuteur);
      bouton.style.height = bouton.offsetHeight + 'px';
      bouton.innerHTML = ok
        ? '\u2713 Ajout\u00E9 \u00E0 votre demande de devis'
        : 'R\u00E9f\u00E9rence manquante';
      bouton.classList.add(ok ? 'f3ddevis2026-bouton--ok' : 'f3ddevis2026-bouton--ko');
      minuteur = setTimeout(function () {
        bouton.innerHTML = libelle;
        bouton.classList.remove('f3ddevis2026-bouton--ok', 'f3ddevis2026-bouton--ko');
        aligner();
      }, 800);
    });

    function majRappel() {
      if (!rappel || !compteur) return;
      var n = F3DDevis2026.nombre();
      var montant = F3DDevis2026.formaterEuros(F3DDevis2026.totalHT());
      rappel.hidden = n === 0;
      if (n === 0) rappel.classList.remove('f3ddevis2026-rappel--anime');
      compteur.textContent = montant + ' HT';
      if (lien) {
        lien.setAttribute('aria-label',
          'Voir ma demande de devis, total ' + montant + ' hors taxes');
      }
    }

    window.addEventListener('resize', function () {
      clearTimeout(attente);
      attente = setTimeout(aligner, 150);
    });

    document.addEventListener('f3ddevis2026:change', majRappel);
    majRappel();
    aligner();
    window.setTimeout(aligner, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', f3ddevis2026InitBouton);
  } else {
    f3ddevis2026InitBouton();
  }
})();
